import { PositionKind } from "../position/types/position-kind";
import {
  PriceUsed,
  PricesUsed,
  pricesUsedOfKind,
} from "../position/types/price-used";
import { ServiceVariation } from "../servicevariation/types/service-variation";

/**
 * wrhPricesUsed returns the prices a WRH position may show per service
 * variation, see `wrhPricesUsed`,
 * backend/core/omni/domain/servicekindrules/wrh_positions.go: full service the
 * unit or the subscription price, the subscription price by default; Kauf the
 * unit or the final price, the unit price by default; without a service
 * variation any, the subscription price by default.
 */
export function wrhPricesUsed(
  kind: PositionKind,
  serviceVariation: ServiceVariation,
): PricesUsed {
  return pricesUsedOfKind(kind, serviceVariation, (of) => {
    switch (of) {
      case ServiceVariation.WRHFullService:
        return {
          allowed: [PriceUsed.UnitPrice, PriceUsed.SubscriptionPrice],
          byDefault: PriceUsed.SubscriptionPrice,
        };
      case ServiceVariation.WRHKauf:
        return {
          allowed: [PriceUsed.UnitPrice, PriceUsed.FinalPrice],
          byDefault: PriceUsed.UnitPrice,
        };
      default:
        return {
          allowed: [
            PriceUsed.UnitPrice,
            PriceUsed.FinalPrice,
            PriceUsed.SubscriptionPrice,
          ],
          byDefault: PriceUsed.SubscriptionPrice,
        };
    }
  });
}
